import styled from "styled-components";

const CardTitle = styled.h3`
  font-size: 20px;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.text};
`;

export default CardTitle;
